module.exports = __webpack_public_path__ + "static/media/icon-complete.fcc22350.svg";